import React from 'react'

function Adddriver() {
  return (
    <>
    <h1 className=" text-3xl font-semibold text-gray-900 m-3 " align='center'>Add Driver</h1>
    <div className=" w-full p-5">
      <div className=' w-full Vehicledetails '>
            <h2 className="text-lg font-semibold ml-3 relative ">Driver Details</h2>
            <div className=" flex justify-center w-full">
                <div className=" w-full borderforform">
                    <div className='flex w-full'>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Driver Name</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Driver Name"/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Licence Number</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Licence Number"/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Date of Birth</label>
                        <input type="date" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Date of Birth"/>
                        </div>
                    </div>
                    <div className='flex w-full'>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Date of Issue</label>
                        <input type="date" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Date of Issue"/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Date of Expiry</label>
                        <input type="date" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Date of Expiry"/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Address</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Address"/>
                        </div>
                    </div>
                    <div className='flex w-full'>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Contact Number</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Contact Number"/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Experience</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Experience"/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Age</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Age"/>
                        </div>
                    </div>
                </div>
            </div>
                <button className="rounded-md bg-lime-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black m-3">
                Add Driver
            </button>
        </div>
        </div>
    </>
  )
}

export default Adddriver